import { createSelector } from 'reselect';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _filter from 'lodash/filter';

const maxDiscountValue = (acc, cur) => (acc.totalDiscount > cur.totalDiscount ? acc : cur);

const getBagItemImageUrl = (state) => {
    let itemImageUrl;
    const bagItems = _get(state.activeCartDraftOrder, 'bag.items', []);
    if (!_isEmpty(bagItems)) {
        itemImageUrl = _get(bagItems[0], 'product.imageURL', undefined);
    }
    return itemImageUrl;
};

const getBadAdjustments = (state) => _get(state.activeCartDraftOrder, 'adjustments', []);
const getBestCouponDetails = (state) => {
    const allCoupons = _get(state.activeCartBestCoupon, 'groups', []);
    const allBestCoupons = _filter(allCoupons, { id: 'BESTCOUPONS' });
    let bestCoupon = null;
    if (!_isEmpty(allBestCoupons)) {
        const bestCoupons = _get(allBestCoupons[0], 'coupons', []);
        if (bestCoupons.length > 0) {
            bestCoupon = bestCoupons.reduce(maxDiscountValue);
        }
    }
    return bestCoupon || {};
};

const getActiveCartDetails = createSelector(
    [getBadAdjustments, getBestCouponDetails, getBagItemImageUrl],
    (bagAdjustments, bestCouponDetails, itemImageUrl) => {
        const activeCartDetails = {
            bestCouponApplied: false,
            bestCouponAvailable: false,
            itemImageURL: itemImageUrl,
            activeCartContent: {},
        };
        if (!_isEmpty(bagAdjustments) && bagAdjustments[0].amount > 0) {
            activeCartDetails.bestCouponApplied = true;
            activeCartDetails.activeCartContent.discount = bagAdjustments[0].amount;
            activeCartDetails.activeCartContent.couponName = bagAdjustments[0].value;
        } else if (!_isEmpty(bestCouponDetails)) {
            activeCartDetails.bestCouponAvailable = true;
            activeCartDetails.activeCartContent.discount = bestCouponDetails.totalDiscount;
            activeCartDetails.activeCartContent.couponName = bestCouponDetails.name;
        }
        return activeCartDetails;
    }
);

export const getActiveCartContentDetails = createSelector([getActiveCartDetails], (cartDetails) => {
    const cartContent = {};
    if (_isEmpty(cartDetails.activeCartContent)) {
        cartContent.context = "You have items in your cart. Grab them before they're gone!";
        cartContent.buttonText = 'View Cart';
        return cartContent;
    }
    /* istanbul ignore else */
    if (cartDetails.bestCouponApplied) {
        cartContent.context = ` with coupon ${cartDetails.activeCartContent.couponName}. Grab your items before they're gone!`;
        cartContent.buttonText = 'View Cart';
        return cartContent;
    }
    /* istanbul ignore else */
    if (cartDetails.bestCouponAvailable) {
        cartContent.context = ` with coupon ${cartDetails.activeCartContent.couponName}. Grab your items before they're gone!`;
        cartContent.buttonText = 'Apply & View Cart';
        return cartContent;
    }
    return cartContent;
});

export default getActiveCartDetails;
